export default {
  account: {
    loading: false,
    token: '',
    exparation: 0,
  },
  needCheckExparation: false,
  init: false,
  token_error: '',
  user: {
    data: null,
    loading: false,
    init: false,
  },
  sidebar: {
    items: [
      { name: 'Главная', route: '/', icon: 'home' },
      {
        name: 'Конфиги',
        icon: 'settings',
        children: [{
          name: 'Все',
          route: '/config',
        }, {
          name: 'Добавление конфига',
          route: '/config/create',
        }],
      },
    ],
  },
};
